import { isObjectRecord } from "../../typeGuards";
import { ArsTableBodyRow } from "../interface";
import { isArsTableBodyCell } from "./isArsTableBodyCell";

/**
 * Type guard for ArsTableBodyRow, which is a possible type of ArsTableRow.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cells' displayContent and annotationContent
 * @returns - True if the object is an ArsTableBodyRow, false otherwise
 */
export const isArsTableBodyRow = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableBodyRow<T> => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.height !== "number") return false;
  if (typeof obj.rowGroup !== "number") return false;
  if (!["boolean", "undefined"].includes(typeof obj.spaceAfterGroup)) return false;
  if (
    !Array.isArray(obj.arsTableCells) ||
    obj.arsTableCells.some((cell) => !isArsTableBodyCell(cell, isT))
  )
    return false;

  // Everything is good
  return true;
};
